import { Typography } from '@mui/material'
import { stepGroups } from '@/features/chat/phase1/stepGroups'
import ActivityPhaseList from './ActivityPhaseList'
import StepGroupRow from './StepGroupRow'
import ThoughtStep from './thoughtchain/ThoughtStep'

export default function StepsSection({
  steps,
  trimmed,
  streaming,
  narrate = false,
  citations = [],
}) {
  if (narrate) {
    return (
      <ActivityPhaseList
        rows={steps}
        trimmed={trimmed}
        streaming={streaming}
        citations={citations}
      />
    )
  }
  return (
    <ThoughtStep category="tasks" title="Steps" streaming={streaming}>
      {trimmed ? (
        <Typography sx={{ fontSize: 'var(--app-thought-font-size)', color: 'var(--app-text-tertiary)' }}>
          Earlier steps not retained
        </Typography>
      ) : null}
      {stepGroups(steps).map((group) => (
        <StepGroupRow key={group.id} group={group} streaming={streaming} />
      ))}
    </ThoughtStep>
  )
}
